var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92513 10.8333H12.2335L8.1668 14.8999C7.8418 15.2249 7.8418 15.7583 8.1668 16.0833C8.4918 16.4083 9.0168 16.4083 9.3418 16.0833L14.8335 10.5916C15.1585 10.2666 15.1585 9.7416 14.8335 9.4166L9.35013 3.9166C9.02513 3.5916 8.50013 3.5916 8.17513 3.9166C7.85013 4.2416 7.85013 4.7666 8.17513 5.0916L12.2335 9.1666H2.92513C2.4668 9.1666 2.0918 9.5416 2.0918 9.99994C2.0918 10.4583 2.4668 10.8333 2.92513 10.8333Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.2412,
    y: 3.80078,
    width: 1.66667,
    height: 12.3981,
    rx: 0.833334,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastPage);
export default __webpack_public_path__ + "static/media/last-page.2bf3764991b2d18d0b4e2c7bae6f050e.svg";
export { ForwardRef as ReactComponent };